<template>
    <div class="erm_reservation_setting">

        <div class="erm_reservation_content">
            <div class="erm_reservation_time">
                <el-tooltip class="box-item"
                    content="Set the reservation time for your restaurant. This will be the time when customers can make reservations."
                    placement="top-start">
                    <div class="demonstration">
                        Reservation Time
                        <el-icon>
                            <InfoFilled />
                        </el-icon>
                    </div>
                </el-tooltip>
                <PairInput :pair="reservation_time" />
            </div>

            <div class="erm_reservation_time">
                <el-tooltip class="box-item"
                    content="Set the reservation time for your restaurant. This will be the time when customers can make reservations."
                    placement="top-start">
                    <div class="demonstration">
                        Reservation Time
                        <el-icon>
                            <InfoFilled />
                        </el-icon>
                    </div>
                </el-tooltip>
                <PairInput :pair="reservation_time" />
            </div>
        </div>


    </div>

</template>
<script>
import PairInput from "../../../components/PairInput.vue";

export default {
    components: {
        PairInput
    },
    data() {
        return {
            reservation_time: [{ value: '10:00 AM' },]

        }
    }

}


</script>

<style lang="scss" scoped>
.erm_reservation_setting {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;

    .erm_reservation_content {
        display: flex;
        justify-content: space-between ;
        align-items: center;
        gap: 20px;
        .erm_reservation_time {
            .demonstration {
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 10px;
                color: var(--font-color);
            }
        }
    }

}
</style>